
const moment = require('moment');
const R = require('ramda');

const utcNow = () => moment.utc().format();


// dataToTag :: Array -> Tag
//    Tag = { id: String,
//            category: String,
//            action: String,
//            label: String,
//            query: String,
//            querySteps: [String] }
const dataToTag = ([id, category, action, label, query = '']) => ({
  id,
  category,
  action,
  label: typeof label == 'string' ? label : R.prop(label.prop),
  query,
  querySteps: query.split(/\s+/)
});


// tagToEvent :: (Tag, Object) -> Event
//    Event = { category: String,
//              action: String,
//              label: String,
//              value: Int,
//              time: UTC }
const tagToEvent = ({ category, action, label, time = utcNow(), extra = {} }) =>
  Object.assign({
    category,
    action,
    label,
    value: 0,
    time
  }, extra);


// toEvent :: (String, String, String, Object) -> Event
const toEvent = (category, action, label, extra) => tagToEvent({
  category,
  action,
  label,
  extra
});


// matchPathToQuery :: Path -> Tag -> Bool
//    Path = [Element] - from event target to html element
const matchPathToQuery = R.curry(
  (path, tag) => {
    const result = path
      .filter(x => x.nodeType === 1) // exclude window and document
      .reduceRight((acc, item) => {
        if (acc.steps.length) {
          const [head, ...tail] = acc.steps;
          const { nodeType } = item;
          if (nodeType === 1 && item.matches(head)) {
            return { lastMatch: item, steps: tail };
          }
        }
        return acc;
      }, { steps: tag.querySteps });

    return !!result.lastMatch && result.steps.length == 0;
  }
);


// parentIterator :: Element -> Iterable Element
const parentIterator = element => ({
  [Symbol.iterator]() {
    return {
      next() {
        const value = element = element.parentElement;
        return { value, done: !value };
      }
    };
  }
});


// toPath :: UIEvent -> [Element]
const toPath = ({ target }) =>
  [target].concat([...parentIterator(target)]);


// uiEventToEvent :: [Tag] -> UIEvent -> [Event]
const uiEventToEvent = tags => uiEvent => {
  const { path = toPath(uiEvent) } = uiEvent;
  const matchedTags = tags.filter(matchPathToQuery(path));
  return matchedTags.map(tagToEvent);
};


module.exports = {
  dataToTag,
  tagToEvent,
  toEvent,
  uiEventToEvent,

  matchPathToQuery,
  parentIterator,
  toPath
};
